import { trackContact } from './analytics';

export function openWhatsApp(phoneNumber: string, message: string) {
  // Track Contact event for Facebook Pixel
  trackContact();

  const text = encodeURIComponent(message);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  const appLink = `whatsapp://send?phone=${phoneNumber}&text=${text}`;
  const apiLink = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${text}`;
  const webLink = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${text}`;

  if (isMobile) {
    // Try to open WhatsApp app; fallback to API web link if app isn't available or blocked
    try {
      // Navigating the current tab increases success rate for deep links on mobile
      window.location.href = appLink;
      // Fallback after a short delay
      setTimeout(() => {
        // If the app didn't open, try API link (works on most mobile browsers)
        window.open(apiLink, "_blank");
      }, 700);
    } catch (_e) {
      window.open(apiLink, "_blank");
    }
  } else {
    // Desktop: open WhatsApp Web
    window.open(webLink, "_blank");
  }
}
